import { useState } from 'react';

interface SuccessAlertState {
  show: boolean;
  title: string;
  message: string;
}

interface ErrorAlertState {
  show: boolean;
  title: string;
  message: string;
}

export const useSubscriptionAlerts = () => {
  const [successAlert, setSuccessAlert] = useState<SuccessAlertState>({
    show: false,
    title: '',
    message: '',
  });

  const [errorAlert, setErrorAlert] = useState<ErrorAlertState>({
    show: false,
    title: '',
    message: '',
  });

  const showSuccessAlert = (message: string, title = '¡Éxito!') => {
    setSuccessAlert({
      show: true,
      title,
      message,
    });
  };

  const showErrorAlert = (message: string, title = 'Error') => {
    setErrorAlert({
      show: true,
      title,
      message,
    });
  };

  const hideSuccessAlert = () => {
    setSuccessAlert(prev => ({ ...prev, show: false }));
  };

  const hideErrorAlert = () => {
    setErrorAlert(prev => ({ ...prev, show: false }));
  };

  const hideAllAlerts = () => {
    setSuccessAlert(prev => ({ ...prev, show: false }));
    setErrorAlert(prev => ({ ...prev, show: false }));
  };

  return {
    successAlert,
    errorAlert,
    showSuccessAlert,
    showErrorAlert,
    hideSuccessAlert,
    hideErrorAlert,
    hideAllAlerts,
  };
};
